module.exports = __webpack_public_path__ + "static/media/trash.66c048a7.svg";